export const DOWNLOAD_FILE_PENDING = '[fileDownload/DOWNLOAD_FILE_PENDING';
export const DOWNLOAD_FILE_SUCCESS = '[fileDownload/DOWNLOAD_FILE_SUCCESS';
export const DOWNLOAD_FILE_ERROR = '[fileDownload/DOWNLOAD_FILE_ERROR';
